import React from "react";
import { Typography, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import brandTheme from "brandTheme/Theme";


const steps = [
  {
    id: "01",
    title: "Apply Online",
    description:
      "Fill in your basic details in a simple application.",
    image: "/images/apply.png",
  },
  {
    id: "02",
    title: "Get Approved",
    description:
      "Instant verification and quick approval.",
    image: "/images/approved.png",
  },
  {
    id: "03",
    title: "Receive Funds",
    description:
      "Money disbursed directly to your bank account.",
    image: "/images/fund.png",
  },
];

const HowItWorksSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const hideLines = useMediaQuery("(max-width:1035px)");
  const isTablet = useMediaQuery("(max-width:800px)");
  return (
    <div
      style={{
        borderRadius: 24,
        padding: "40px 32px",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isTablet
            ? "1fr"
            : "repeat(auto-fit,minmax(150px,1fr))",
          gap: 32,
          alignItems: "center",
        }}
      >
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 20,
              }}
            >
              <div
                style={{
                  width: 90,
                  height: 90,
                  borderRadius: "50%",
                  background: brandTheme.backgroundColor,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow:
                    "0 15px 45px rgba(61, 10, 28, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
                  flexShrink: 0,
                }}
              >
                <img
                  src={step.image}
                  alt={step.title}
                  style={{
                    width: 60,
                    height: 60,
                    objectFit: "contain",
                  }}
                />
              </div>

              <div>
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: 700,
                    color: "#15254F",
                    marginBottom: 6,
                  }}
                >
                  {step.title}
                </Typography>

                <Typography
                  variant="body2"
                  style={{
                    color: "#4F5D75",
                    lineHeight: 1.7,
                  }}
                >
                  {step.description}
                </Typography>
              </div>
            </div>

            {/* Hide connector on small screens */}
            {!isMobile && index !== steps.length - 1 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: 100,
                    borderTop: `2px dashed ${brandTheme.secondaryColor}`,
                  }}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default HowItWorksSection;